// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2Tyls","options":"AnswerScale_options__3kM8k","selected":"AnswerScale_selected__5vmip"};